import React, { useRef } from 'react';
import { Number } from 'react-intl-number-format';
//import { Button } from 'primereact/button';
//import { useCopyToClipboard } from 'usehooks-ts';
import { Toast } from 'primereact/toast';
//import axios from 'axios';

const QuotationPayment = ({ quotation, payment }) => {
    //const [generatingPaymentLink, setGeneratingPaymentLink] = useState(false);
    //const [paymentLink, setPaymentLink] = useState(quotation.link_pago);
    //const [, copyPaymentLinkToClipboard] = useCopyToClipboard();
    //const [clipboardTooltip, setClipboardTooltip] = useState('Copiar');
    const toast = useRef(null);

    /* 
    const generatePaymentLink = () => {
        setGeneratingPaymentLink(true);
        axios
            .put('/quotations/' + quotation.id_registro + '/paymentLink')
            .then((response) => {
                setPaymentLink(response.data.link);
                copyPaymentLinkToClipboard(response.data.link);
                toast.current.clear();
                toast.current.show({ severity: 'success', detail: 'Se ha generado un nuevo link de pago y copiado al portapapeles.' });
            })
            .catch(() => {
                toast.current.clear();
                toast.current.show({ severity: 'error', detail: 'Ha ocurrido un error interno. Intente nuevamente.' });
            })
            .finally(() => {
                setGeneratingPaymentLink(false);
            });
    };
    
    const copyPaymentLink = () => {
        copyPaymentLinkToClipboard(paymentLink);
        setClipboardTooltip('Copiado');
    };
    */
    return (
        <div>
            <Toast ref={toast} position="bottom-right" />
            <div className="card-body">
                <div className="grid mt-3">
                    <div className="row">
                        <h4>Pago #{payment.id_pago}</h4>
                        <div className="col-md-8">
                            <div className="row pt-2">
                                <div className="col-md-6 pb-2 d-flex">
                                    <span className="form-label fw-bold">Precio total: </span> $<Number locale="es-CL">{payment.precio_total}</Number>
                                </div>
                                <div className="col-md-6 pb-2">
                                    <span className="form-label fw-bold">Respondido por: </span> {payment.usuario}
                                </div>
                                <div className="col-md-6 pb-2">
                                    <span className="form-label fw-bold">Tiempo de despacho: </span> {payment.dias_despacho} días (Hábiles).
                                </div>
                                <div className="col-md-6 pb-2">
                                    <span className="form-label fw-bold">Fecha de respuesta: </span> {payment.fecha_cotizado}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row pt-2">
                                <div className="col pb-2">
                                    <span className="form-label fw-bold">Comentario: </span> {payment.mensaje}
                                </div>
                                {quotation && <div></div>}
                                {/* 
                                <div className="col-md-6 pb-2">
                                    <Button
                                        type="button"
                                        className="text-nowrap"
                                        severity="secondary"
                                        icon="bi bi-link-45deg"
                                        label="Generar link de pago"
                                        onClick={generatePaymentLink}
                                        loading={generatingPaymentLink}
                                        disabled={quotation.estado !== 'Cotizado'}
                                    />
                                </div>
                                */}
                            </div>
                        </div>
                        {/* 
                        {paymentLink && (
                            <div className="col-12 d-flex align-items-center">
                                <span className="form-label fw-bold mb-0">Link de pago: </span>
                                <span className="mx-3">
                                    <a href={paymentLink} target="_blank" rel="noreferrer">
                                        {paymentLink}
                                    </a>
                                </span>
                                <Button
                                    type="button"
                                    severity="secondary"
                                    icon="bi bi-clipboard"
                                    outlined
                                    tooltip={clipboardTooltip}
                                    tooltipOptions={{
                                        onHide: () => {
                                            setClipboardTooltip('Copiar');
                                        },
                                    }}
                                    onClick={copyPaymentLink}
                                />
                            </div>
                        )}
                        */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuotationPayment;
